import { Menu } from 'lucide-react';
import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { navItems } from '../../data/site';
import { Button } from '../ui/Button';
import { MobileNavigation } from './MobileNavigation';

export function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <>
      <header className="relative z-40 border-b border-slate-800/60 bg-ink/75 shadow-[0_10px_40px_rgba(0,0,0,0.12)] backdrop-blur-xl">
        <div
          className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-crimson-500/60 to-transparent"
          aria-hidden="true"
        />
        <div className="mx-auto flex h-[4.75rem] max-w-shell items-center justify-between px-5 sm:px-8 lg:px-10">
          <Link
            to="/"
            className="focus-ring flex items-center gap-2.5"
            aria-label="CrimsonSky IT home"
          >
            <img
              src="/branding/crimsonsky-symbol.png"
              alt=""
              className="h-9 w-9 object-contain"
              aria-hidden="true"
            />
            <span className="hidden text-[0.76rem] font-bold tracking-[0.18em] text-white sm:inline">
              CRIMSONSKY IT
            </span>
          </Link>
          <nav className="hidden items-center gap-8 lg:flex" aria-label="Primary navigation">
            {navItems.map((item) => (
              <NavLink
                key={item.href}
                to={item.href}
                className={({ isActive }) =>
                  `focus-ring group relative py-2 text-sm transition ${isActive ? 'text-white' : 'text-slate-400 hover:text-white'}`
                }
              >
                {({ isActive }) => (
                  <>
                    {item.label}
                    <span
                      className={`absolute inset-x-0 -bottom-1 h-px origin-left bg-crimson-400 transition duration-300 ${isActive ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100'}`}
                      aria-hidden="true"
                    />
                  </>
                )}
              </NavLink>
            ))}
          </nav>
          <div className="flex items-center gap-3">
            <Button to="/contact" className="hidden sm:inline-flex">
              Let’s talk
            </Button>
            <button
              className="focus-ring rounded-lg p-2 text-slate-300 hover:bg-slate-800 lg:hidden"
              onClick={() => setMobileOpen(true)}
              aria-label="Open navigation"
              aria-expanded={mobileOpen}
              aria-controls="mobile-navigation"
            >
              <Menu size={22} />
            </button>
          </div>
        </div>
      </header>
      <MobileNavigation open={mobileOpen} onClose={() => setMobileOpen(false)} />
    </>
  );
}
